import React from 'react';
import BasePageContainer from 'src/components/CommonV2Components/BasePageContainer/BasePageContainer';
import UnitsReturnedProductGrid from './UnitsReturnedProductGrid';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { BEACON_CHART_SPACING } from 'src/components/Layout/Beacon/BeaconProLayoutConsts';
import BeaconComparableSplineChart from 'src/components/BeaconV2Components/BeaconMetricSplineChart/BeaconComparableSplineChart';
import BeaconDropdownMetricColumnChart from 'src/components/BeaconV2Components/BeaconMetricColumnChart/BeaconDropdownMetricColumnChart';
import { useMainEntityType } from 'src/utils/Hooks/reduxSelectors';

/**
 * Sales Return Page
 */
const ReturnsPage = () => {
  const entityType = useMainEntityType();

  return (
    <BasePageContainer>
      <Flex flexDirection="column" gap={BEACON_CHART_SPACING}>
        <BeaconComparableSplineChart indexName="sales" fieldName="returnRate" />
        <BeaconComparableSplineChart indexName="sales" fieldName="unitsReturned" />
        <BeaconComparableSplineChart indexName="sales" fieldName="returnRetailValue" />
        <BeaconDropdownMetricColumnChart
          indexName="sales"
          fieldName="returnRate"
          dropdownOptions={[
            {
              id: 'subCategoryId',
              label: 'Subcategory'
            },
            {
              id: 'categoryId',
              label: 'Category'
            },
            {
              id: 'brandId',
              label: 'Brand'
            }
          ].filter((option) => !option.id.toLowerCase().startsWith(entityType))}
          titlePrefix="Return Rate % by"
        />
        <UnitsReturnedProductGrid />
      </Flex>
    </BasePageContainer>
  );
};

export default ReturnsPage;
